import { render } from "./contactList.vue?vue&type=template&id=28069ef7&scoped=true"
import script from "./contactList.vue?vue&type=script&lang=js"
export * from "./contactList.vue?vue&type=script&lang=js"

import "./contactList.vue?vue&type=style&index=0&id=28069ef7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28069ef7"]])

export default __exports__